import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CART_STORE_TYPE, SavedPartListComponentStore } from 'cart-data';
import { ProductTypes } from 'products-data';
import { CartItemResultListComponent, provideCartItemResultComponent } from '../../cart-item';
import { SavedPartListItemComponentProviderComponent } from '../saved-part-list-item-component-provider/saved-part-list-item-component-provider.component';
import { SectionComponent } from 'page-layouts-ui';

const components = ProductTypes.Codes.All.map((type) =>
  provideCartItemResultComponent({
    type: ProductTypes.fromCode(type),
    component: SavedPartListItemComponentProviderComponent,
    merge: true,
  }),
).flat();

@Component({
  selector: 'ideal-saved-part-list-results',
  imports: [CartItemResultListComponent, SectionComponent],
  templateUrl: './saved-part-list-results.component.html',
  styleUrl: './saved-part-list-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CART_STORE_TYPE,
      useValue: SavedPartListComponentStore,
    },
    components,
    provideCartItemResultComponent({
      type: ProductTypes.Standard,
      component: SavedPartListItemComponentProviderComponent,
      merge: true,
    }),
  ],
})
export class SavedPartListResultsComponent {
  private readonly _store = inject(SavedPartListComponentStore);
  private readonly _items = computed(() => this._store.cartItems());
  protected readonly ids = computed(() => this._items().map((item) => item.id));
  protected readonly cart = computed(() => this._store.cart());
  protected readonly cartName = computed(() => this.cart()?.name ?? '');
  protected readonly title = computed(() => `Items in ${this.cartName()}`);
}
